// extracted by mini-css-extract-plugin
module.exports = {"LoginBox":"LoginBox_LoginBox__C9E8v","LoginBox_logo":"LoginBox_LoginBox_logo__Z9txt","LoginBox_heading":"LoginBox_LoginBox_heading__E7IK0"};